// extracted by mini-css-extract-plugin
export default {"dropdown":"src-components-GlobalHeader-HeaderDropdown-index-module__dropdown--CupiC"};